<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M417 1234 c-34 -19 -49 -56 -41 -100 l6 -34 -49 0 c-54 0 -83 -20
-83 -57 0 -19 -7 -21 -79 -24 -132 -6 -121 36 -121 -484 0 -415 1 -443 18
-458 16 -15 53 -17 317 -17 l298 0 -23 25 -23 25 -249 0 c-235 0 -249 1 -268
20 -19 19 -20 33 -20 403 0 446 -4 427 88 427 46 0 60 -4 70 -20 11 -19 23
-20 207 -20 184 0 196 1 207 20 10 16 24 20 70 20 75 0 88 -17 88 -117 l0 -72
31 11 31 11 -4 88 c-4 119 -17 132 -128 137 -74 4 -80 6 -80 26 0 40 -17 51
-82 56 l-62 5 2 45 c3 37 -1 50 -20 67 -32 30 -68 36 -101 17z m83 -34 c40
-40 18 -90 -38 -90 -44 0 -62 14 -62 49 0 55 61 80 100 41z"
      />
      <path
        d="M230 800 c-27 -27 -25 -55 6 -79 34 -27 40 -26 70 4 18 19 23 31 19
48 -15 47 -61 61 -95 27z"
      />
      <path
        d="M413 774 c-17 -44 105 -61 162 -24 19 13 47 20 78 20 30 0 46 4 42
10 -4 6 -62 10 -141 10 -116 0 -136 -2 -141 -16z"
      />
      <path
        d="M890 758 c-36 -11 -78 -20 -95 -20 -16 1 -62 2 -102 4 -80 3 -108
-10 -150 -72 -38 -55 -31 -111 38 -315 86 -252 105 -285 165 -285 42 0 69 32
119 144 l39 88 29 -104 c16 -56 36 -111 45 -120 22 -26 74 -23 101 6 12 13 54
108 93 212 62 164 72 200 75 269 5 91 -8 123 -69 167 -70 53 -174 62 -288 26z
m235 -48 c109 -53 103 -148 -29 -475 -38 -95 -47 -110 -67 -110 -21 0 -26 12
-57 118 -31 104 -37 117 -57 117 -30 0 -49 -23 -90 -115 -57 -127 -56 -126
-84 -123 -27 3 -22 -8 -117 248 -71 193 -70 283 2 318 30 14 42 14 97 3 34 -7
100 -26 147 -43 119 -42 140 -45 140 -20 0 22 -33 47 -88 67 l-37 13 35 10
c61 18 159 14 205 -8z"
      />
      <path
        d="M1004 578 c-68 -66 -104 -109 -104 -123 0 -28 40 -65 71 -65 33 0
219 185 219 218 0 27 -42 72 -66 72 -9 0 -63 -46 -120 -102z m166 50 c14 -27
14 -29 -15 -58 l-31 -30 -34 35 -34 35 24 25 c31 33 69 30 90 -7z m-90 -133
l-34 -35 -35 35 -35 35 34 35 34 35 35 -35 35 -35 -34 -35z m-70 -70 c-27 -29
-46 -31 -72 -8 -24 22 -23 52 4 80 l22 24 35 -35 35 -35 -24 -26z"
      />
      <path
        d="M1013 545 c-10 -10 -9 -16 2 -25 16 -13 35 -5 34 13 0 9 -2 9 -6 0
-8 -21 -25 -14 -18 7 7 23 5 25 -12 5z"
      />
      <path
        d="M225 590 c-35 -39 6 -99 59 -86 15 4 32 17 38 31 26 57 -55 102 -97
55z"
      />
      <path
        d="M414 565 c-9 -24 5 -35 45 -35 35 0 38 2 33 25 -4 21 -10 25 -38 25
-21 0 -37 -6 -40 -15z"
      />
      <path
        d="M224 365 c-14 -21 -15 -31 -6 -51 14 -30 33 -38 67 -30 62 16 49 106
-15 106 -21 0 -35 -8 -46 -25z"
      />
      <path
        d="M425 356 c-11 -8 -16 -19 -12 -30 5 -13 21 -16 77 -16 72 0 79 5 60
41 -8 15 -21 19 -58 19 -27 0 -57 -6 -67 -14z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
